import React from "react";
import { Container, Row} from "reactstrap";
import PlaybookManagerTable from "./IncidentTable";

const IncidentOverview = () => {
  document.title = "Dashboard | Risknox";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
           <Row>
             <PlaybookManagerTable />
           </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default IncidentOverview;
